// One place for the user-facing copy of each provider API error.
export const REGISTRY_DOWN = "The NPI Registry isn't responding. Try again, or add without an NPI."
export const AUDIT_NOT_READY = "This audit's scan isn't finished yet. Try again once it's done."

export const QUESTIONS_CHANGED = 'These provider questions changed. Showing the latest.'
export const NO_QUESTION_SET = "We couldn't find provider questions for this audit. Try again."

export function errorCode(e) {
  const res = e?.response
  if (res?.status === 409 && res?.data?.error === 'stage_changed') return 'stage_changed'
  if (res?.status === 404 && res?.data?.error === 'no_question_set') return 'no_question_set'
  if (res?.status === 503 || res?.data?.code === 'npi_registry_unavailable') return 'npi_registry_unavailable'
  return res?.data?.code || null
}

// The form's copy of the set is out of date: the stage moved (409), or the ids it sent no longer
// belong to the set (422 invalid), as when another tab went back and regenerated the questions.
export function isStale(e) {
  const res = e?.response
  if (errorCode(e) === 'stage_changed') return true
  return res?.status === 422 && res?.data?.error === 'invalid'
}

export function errorMessage(e, fallback) {
  const code = errorCode(e)
  if (code === 'npi_registry_unavailable') return REGISTRY_DOWN
  if (code === 'stage_changed') return QUESTIONS_CHANGED
  if (code === 'no_question_set') return NO_QUESTION_SET
  if (code === 'audit_not_ready') return AUDIT_NOT_READY
  if (code === 'invalid' && e.response?.data?.error) return e.response.data.error
  return fallback
}
